import { FetchResult, gql } from 'apollo-boost';
import { MultiError } from '../../../types/multi-error';
import { graphqlClient } from '../../graphql-client';

const MUTATION = gql`
    mutation UserSendOneTimeLoginCode($email: String!){
        user_send_one_time_login_code(email: $email) {
            success
        }
    }
`;

export async function requestOneTimeCode(email: string): Promise<{ success: boolean }> {
    const result: FetchResult<{ user_send_one_time_login_code: { success: boolean } }> = await graphqlClient.mutate({
        mutation: MUTATION,
        variables: { email },
        errorPolicy: 'all',
    });

    if(!result.data || (result.errors && result.errors.length)) {
        throw new MultiError(result.errors || ['Unknown error']);
    }

    return result.data.user_send_one_time_login_code;
}
